const getUniqueDummy = () => {
  const id = `unique-id-${Math.random()}`;
  return { id, loading: true };
};

export function generateDummyData(n) {
  return Array.from({ length: n }).map(getUniqueDummy);
}
